import React from 'react'

const HelpAndResourcesPage = () => {
  return (
    <div>HelpAndResourcesPage</div>
  )
}

export default HelpAndResourcesPage